import { createReducer, on } from '@ngrx/store';
import { defaultRoleListFilter } from '../types/role-list-filter';
import {
  fetchRoleList,
  loadedRoleList,
  failedRoleList,
  updateRoleListFilter,
  resetRoleList,
  deleteRole,
} from './role-list.actions';
import {
  initialRoleListState,
  RoleListState,
  initialDataSource,
} from './role-list.state';
import { RoleListInterface } from '../types/role-list';

export const roleListReducer = createReducer(
  initialRoleListState,
  on(fetchRoleList, (state): RoleListState => ({ ...state })),
  on(loadedRoleList, (state, action): RoleListState => {
    return {
      ...state,
      filter: { ...state.filter },
      dataSource: action.dataSource,
    };
  }),
  on(failedRoleList, (state): RoleListState => {
    return {
      ...state,
      filter: { ...state.filter },
      dataSource: { ...initialDataSource },
    };
  }),
  on(updateRoleListFilter, (state, { filter }): RoleListState => {
    return {
      ...state,
      filter: { ...state.filter, ...(filter ?? defaultRoleListFilter) },
      dataSource: { ...state.dataSource },
    };
  }),
  on(deleteRole, (state, action): RoleListState => {
    return {
      ...state,
      filter: { ...state.filter },
      dataSource: {
        ...state.dataSource,
        rawData: state.dataSource.rawData?.filter(
          (role: RoleListInterface) => role.role_id !== action.role_id
        ),
      },
    };
  }),
  on(resetRoleList, (state): RoleListState => {
    return {
      ...state,
      filter: { ...defaultRoleListFilter },
      dataSource: { ...state.dataSource },
    };
  })
);
